var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 27.5,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0 27.5)",
    fill: "var(--color-primary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.3952C10.5 18.5498 10.5644 18.7067 10.6899 18.8239C10.9412 19.0587 11.3567 19.0587 11.608 18.8239L16.3101 14.4313C16.4314 14.318 16.5 14.158 16.5 14.0026C16.5 13.8487 16.44 13.6952 16.3101 13.5739L11.6141 9.1873C11.3665 8.94156 10.9412 8.93844 10.6899 9.17317C10.4386 9.40791 10.4386 9.79607 10.6899 10.0308L10.6901 10.031L14.9415 13.9949L10.6899 17.9666C10.5642 18.0841 10.5 18.2408 10.5 18.3952Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.ce1b862ff05fe5aaa0affd31fc6ffc22.svg";
export { ForwardRef as ReactComponent };